<template>
  <div class="zzc">
    <div class="msg" ref="msg">
      <div class="top">
        <img src="../assets/imgs/warning.png" />
        <p>安全告警</p>
        <p></p>
      </div>
      <el-form ref="form" :model="info" label-width="120px" class="forms">
        <el-form-item label="告警类型:">
          <el-select
            v-model="info.type"
            placeholder="请选择"
            disabled
            style="width: 100%"
          >
            <el-option
              v-for="(item, index) in typeList"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="姓名:">
          <el-input
            v-model="info.customerName"
            disabled
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号:">
          <el-input
            v-model="info.customerPhone"
            placeholder=""
            disabled
            style="width: 88%"
          ></el-input>
          <i
            class="el-icon-phone"
            title="电话"
            @click="callPhone(info.customerPhone, '1')"
          ></i>
        </el-form-item>
        <el-form-item label="详细地址:">
          <el-input
            v-model="info.address"
            disabled
            type="textarea"
            placeholder=""
          ></el-input>
        </el-form-item>
        <el-form-item label="紧急联系方式:">
          <el-input
            v-model="info.urgentPhone"
            placeholder=""
            disabled
            style="width: 88%"
          ></el-input>
          <i
            class="el-icon-phone"
            title="电话"
            @click="callPhone2(info.urgentPhone, '1')"
          ></i>
        </el-form-item>
        <el-form-item label="机构联系人:">
          <el-input
            v-model="info.stationPhone"
            placeholder=""
            style="width: 88%"
            disabled
          ></el-input>
          <i
            class="el-icon-phone"
            title="电话"
            @click="callPhone1(info.stationPhone, '1')"
          ></i>
        </el-form-item>
        <el-form-item label="处理内容">
          <el-input
            v-model="info.remarks"
            type="textarea"
            placeholder=""
          ></el-input>
        </el-form-item>
        <div class="dialog-footer">
          <el-button @click="close()">取 消</el-button>
          <el-button type="primary" @click="save()">确 定</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request.js"
import baseURL from "@/api/baseURL"
import axios from "axios"
import exportVue from "@/utils/exportVue"
export default {
  name: "msg",
  mounted() {},
  data() {
    return {
      info: {},
      infos: {},
      List: [{ id: 1, name: "2" }],
      rights: 40,
      bottoms: 30,
      wy: "",
      alldata: {},
      infoIndex: 0,
      Isaudio: false,
      allType: [],
      typeList: [
        { id: "1", name: "紧急按钮" },
        { id: "2", name: "门磁" },
        { id: "3", name: "烟感" },
        { id: "4", name: "燃气" },
        { id: "5", name: "水浸" },
        { id: "6", name: "红外" },
        { id: "7", name: "手环" },
        { id: "8", name: "床垫" },
        { id: "9", name: "血糖仪" },
        { id: "10", name: "颐养卡" },
        { id: "11", name: "血压计" },
        { id: "12", name: "智能门锁" },
      ],
    }
  },
  props: ["infoList"],
  created() {
    exportVue.$on("infoList", (data) => {
      this.info = data
      this.info.type = String(this.info.type)
      console.log(this.info, data, "")
      console.log("kkkk")
    })
  },
  methods: {
    getTime() {
      let ul = baseURL.substr(7, 12)
      var websocket = null
      if ("WebSocket" in window) {
        websocket = new WebSocket("ws://" + ul + ":10004/websocket")
      } else {
        alert("该浏览器不支持websocket!")
      }

      websocket.onopen = function (event) {
        console.log("建立连接")
      }

      websocket.onclose = function (event) {
        console.log("连接关闭")
      }

      websocket.onmessage = (event) => {
        this.infoIndex = this.infoIndex + 1
        if (JSON.parse(event.data).dataId == this.$store.state.info.dataId) {
          this.infos = JSON.parse(event.data)
          this.allType.push(this.infos)
          if (this.allType.length == 1) {
            console.log("是否再次点击")
            this.$emit("close", true)

            this.$refs.audio.play()
            console.log(this.$refs.audio, "this.$refs.audio")
            this.info = this.allType[0]
            this.info.type = String(this.info.type)
          }
          console.log(this.allType, "this.allType")
          // exportVue.$emit("all", this.infoIndex)
        }
        setTimeout(async () => {
          this.allType.forEach((item, index) => {
            if (item.msgKey == this.info.msgKey) {
              this.allType.splice(index, 1)
            }
          })
          if (this.allType.length > 0) {
            this.$emit("close", true)
            this.$refs.audio.play()
            this.info = this.allType[0]
            this.info.type = String(this.info.type)
          } else {
            this.$emit("close", false)
            this.$refs.audio.pause()
          }
        }, 50000)
      }

      websocket.onerror = function () {
        alert("websocket通信发生错误！")
      }

      window.onbeforeunload = function (event) {
        websocket.close()
      }
    },
    callPhone(phone) {
      if (phone) {
        this.$router.push({
          name: "customerInfo",
          params: { phone: phone },
        })
      }
    },
    callPhone1(phone) {
      if (phone) {
        this.$router.push({
          name: "customerInfo",
          params: { phone: phone },
        })
      }
    },
    callPhone2(phone) {
      if (phone) {
        this.$router.push({
          name: "customerInfo",
          params: { phone: phone },
        })
      }
    },
    save() {
      axios({
        method: "post",
        url: baseURL + "/ypt/admin/warningInfo/info/saveWarningInfo",
        data: {
          remarks: this.info.remarks,
          disposalStatus: 1,
          msgKey: this.info.msgKey,
        },
      })
        .then((res) => {
          // if (res.data.code == 200) {
          this.$emit("close", false)
        })
        .catch((error) => {
          this.$message.error(res.data.mesage)
        })
    },
    close() {
      this.$emit("close", false)
    },
  },
}
</script>
<style lang="less" scoped>
/deep/.el-input {
  width: 100%;
}
.msg {
  position: fixed;
  z-index: 999;
  top: 18%;
  width: 500px;
  margin: 0 40%;
  border: 1px solid #b5b5b5;
  .top {
    background: #3f5292;
    height: 140px;
    width: 100%;
    text-align: center;
    p {
      color: #fff;
    }
    img {
      margin: 5px;
    }
  }
  .forms {
    padding: 20px 20px;
    background: #f5f5f5;
    .el-icon-phone {
      margin-left: 14px;
      cursor: pointer;
    }
  }
}
/deep/.el-input__inner {
  background-color: #f5f5f5;
}
/deep/.el-textarea__inner {
  background-color: #f5f5f5;
  color: #000000;
  font-weight: bold;
  font-size: 18px;
}
.dialog-footer {
  text-align: center;
}
/deep/.el-button--primary {
  background-color: #3f5292;
  margin-left: 8px;
}
/deep/.el-button--default {
  background: #9fa8c5;
  color: #fff;
}
/deep/.el-button {
  padding: 8px 28px;
}
/deep/.el-input.is-disabled .el-input__inner {
  color: #000000;
  font-weight: bold;
  font-size: 18px;
}
/deep/.el-textarea.is-disabled .el-textarea__inner {
  color: #000000;
  font-weight: bold;
  font-size: 18px;
}
/deep/.el-form-item__label {
  color: #000000;
}
.zzc {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 666;
  background: rgba(0, 0, 0, 0.3);
}
</style>
